/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-14 17:45:57
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-02-08 10:25:09
 * @FilePath: \baishu_react_ui\src\components\BsyBatchEditPane\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import { BsyUtils } from "../../utils/Utils";
import BsyAlert from "../BsyAlert";
import BsyCheckGroup from "../BsyCheckGroup";
import BsyExcelGrid from "../BsyExcelGrid";
import BsyIconBtn from "../BsyIconBtn";
import BsySelect from "../BsySelect";
import BsySLoading from "../BsySLoading";
import BsyStepPane from "../BsyStepPane";
import BsyTextEditor from "../BsyTextEditor";
import { BsyWidget } from "../BsyWidget";
import "./index.css";
import { BsyConfig, SUBFORM_MAX_LIMIT } from "../../global/BsyConfig";
import { dayjsUtils } from "../../utils/dayjsUtils";

export default class BsySubformImportPane extends BsyWidget {
  static defaultProps = {
    baseCls: "bsy-subform-import-pane",
    currentStep: 0,
    status: "selectExcel", // dataPreview formSet importData

    importMode: 0,
    formItems: [],
    importCheckallowBlank: false,
    importCheckrepeat: false,
    importStartFlow: false,
    hasFlow: false,
    hasSubform: false,
    importDataExtendSet: {
      enable: false,
      datahelpids: [],
    },
    importData: {},
    sheet: null,
    fileinfo: {},
    // items: [],
    // heads: [],
    matchHead: { heads: [], items: [] },
    getSample: { heads: [], items: [] },
    isLoading: false,
    hasError: false,
    limit: 200,
  };
  constructor(props) {
    super(props);
    this.state = {
      steps: [
        React.language("import.excel.select"),
        React.language("etl.stage.preview"),
        React.language("form.config.ext"),
        React.language("import.excel.data"),
      ],
      ...props,
    };

    this.element = React.createRef();
    this.extendSetElement = React.createRef();
    this.nextImport = React.createRef();
    this.excelGridIndex = 1;
    this._initFormItems();
  }

  _initFormItems = () => {
    let a = this.options,
      b = this;
    this.formItems = [];
    this.widgetsMap = {};
    BsyUtils.forEach(a.fields, function (a, c) {
      if (!(BsyConfig().LimitFields.import.indexOf(c.widget.type) < 0)) {
        if ("subform" === c.widget.type) {
          b.widgetsMap[c.widget.widgetName] = {
            field: c.widget.widgetName,
            noRepeat: c.widget.noRepeat,
            allowBlank: c.widget.allowBlank,
            text: c.label,
            type: c.widget.type,
            items: [],
          };
          BsyUtils.forEach(c.widget.items, function (a, d) {
            if (
              BsyConfig().LimitFields.import.indexOf(d.widget.type) > -1
            ) {
              if (d.widget.type === "address" || d.widget.type === "location") {
                let d1 = [
                  {
                    v: "province",
                    t: React.language("widget.address.province.withMark"),
                  },
                  {
                    v: "city",
                    t: React.language("city.withMark"),
                  },
                  {
                    v: "district",
                    t: React.language("widget.address.district.withMark"),
                  },
                ];
                d.widget.needDetail &&
                  d1.push({
                    v: "detail",
                    t: React.language("widget.address.detail.withMark"),
                  });
                BsyUtils.forEach(d1, function (a1, d1) {
                  let e = [d.widget.widgetName, d1.v].join("-");
                  b.formItems.push({
                    value: e,
                    text: [c.label, d.label].join(".") + d1.t,
                  });
                  b.widgetsMap[e] = {
                    field: d.widget.widgetName,
                    type: d.widget.type,
                    noRepeat: d.widget.noRepeat,
                    allowBlank: d.widget.allowBlank,
                    subform: c.widget.widgetName,
                    part: d1.v,
                  };
                });
              } else {
                b.widgetsMap[d.widget.widgetName] = {
                  type: d.widget.type,
                  noRepeat: d.widget.noRepeat,
                  allowBlank: d.widget.allowBlank,
                  field: d.widget.widgetName,
                  text: d.label,
                  subform: c.widget.widgetName,
                };
                b.widgetsMap[c.widget.widgetName].items.push(
                  b.widgetsMap[d.widget.widgetName]
                );
                if (d.widget.type === "combo" || d.widget.type === "combocheck") {
                  if (d.widget.async) {
                    b.widgetsMap[d.widget.widgetName].async = d.widget.async;
                  } else {
                    b.widgetsMap[d.widget.widgetName].items = b._extSelected(
                      d.widget.items
                    );
                  }
                } else if (
                  d.widget.type === "radiogroup" ||
                  d.widget.type === "checkboxgroup"
                ) {
                  b.widgetsMap[d.widget.widgetName].items = b._extSelected(
                    d.widget.items
                  );
                } else if (d.widget.type === "datetime") {
                  b.widgetsMap[d.widget.widgetName].format = d.widget.format;
                }

                b.formItems.push({
                  value: d.widget.widgetName,
                  text: [c.label, d.label].join("."),
                });
              }
            }
          });
        } else if ("address" === c.widget.type) {
          let d = [
            {
              v: "province",
              t: React.language("widget.address.province.withMark"),
            },
            {
              v: "city",
              t: React.language("city.withMark"),
            },
            {
              v: "district",
              t: React.language("widget.address.district.withMark"),
            },
          ];
          c.widget.needDetail &&
            d.push({
              v: "detail",
              t: React.language("widget.address.detail.withMark"),
            });
          BsyUtils.forEach(d, function (a, d) {
            let e = [c.widget.widgetName, d.v].join("-");
            b.formItems.push({
              value: e,
              text: c.label + d.t,
            });
            b.widgetsMap[e] = {
              field: c.widget.widgetName,
              noRepeat: c.widget.noRepeat,
              allowBlank: c.widget.allowBlank,
              type: c.widget.type,
              part: d.v,
            };
          });
        } else {
          if ("subform" !== c.widget.type) {
            b.formItems.push({
              value: c.widget.widgetName,
              text: c.label,
            });
            b.widgetsMap[c.widget.widgetName] = {
              field: c.widget.widgetName,
              noRepeat: c.widget.noRepeat,
              allowBlank: c.widget.allowBlank,
              text: c.label,
              type: c.widget.type,
            };
          }

          if (c.widget.type === "combo" || c.widget.type === "combocheck") {
            if (c.widget.async) {
              b.widgetsMap[c.widget.widgetName].async = c.widget.async;
            } else {
              b.widgetsMap[c.widget.widgetName].items = b._extSelected(
                c.widget.items
              );
            }
          } else if (
            c.widget.type === "radiogroup" ||
            c.widget.type === "checkboxgroup"
          ) {
            b.widgetsMap[c.widget.widgetName].items = b._extSelected(
              c.widget.items
            );
          } else if (c.widget.type === "datetime") {
            b.widgetsMap[c.widget.widgetName].format = c.widget.format;
          }
        }
      }
    });
  };
  _extSelected = (items) => {
    let bb = [];
    BsyUtils.forEach(items, function (a1, b1) {
      if (b1.hasOwnProperty("selected")) {
        delete b1.selected;
      }
      bb.push(b1);
    });
    return bb;
  };

  componentDidMount() {
    super.componentDidMount();
  }

  downTemplte = () => {
    let b = this,
      c = this.options;
    let template = [[]];
    for (let k = 0; k < c.fields.length; k++) {
      if (
        BsyConfig().LimitFields.import.indexOf(c.fields[k].widget.type) !=
        -1
      ) {

        // 子表单中不支持图片的导入
        if (c.fields[k].widget.type === 'image') {
          continue;
        }

        if (c.fields[k].widget.type === "address") {
          template[0].push(
            c.fields[k].label +
            React.language("widget.address.province.withMark")
          );
          template[0].push(c.fields[k].label + React.language("city.withMark"));
          template[0].push(
            c.fields[k].label +
            React.language("widget.address.district.withMark")
          );
          if (c.fields[k].widget.needDetail === true) {
            template[0].push(
              c.fields[k].label +
              React.language("widget.address.detail.withMark")
            );
          }
        } else {
          template[0].push(c.fields[k].label.toString());
        }
      }
    }
    let wopts = { bookType: "xlsx", bookSST: false, type: "binary" };
    let wb = { SheetNames: ["Sheet1"], Sheets: {}, Props: {} };
    // wb.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(template);
    wb.Sheets["Sheet1"] = window.XLSX.utils.aoa_to_sheet(template);
    let down = new Blob([b._s2ab(window.XLSX.write(wb, wopts))], {
      type: "application/octet-stream",
    });
    let href = URL.createObjectURL(down);
    let link = document.createElement("a");
    link.href = href;
    link.download = React.language("etl.input.subform") + "_tpl.xlsx";
    link.click();
    window.URL.revokeObjectURL(link.href);
  };

  _column_2_number = (s) => {
    let result = 0;
    let len = s.length;
    let ch;
    let A = "A".charCodeAt();
    for (let i = len - 1; i >= 0; i--) {
      ch = s[i];
      ch = s.charCodeAt(i);
      result = result + (ch - A + 1) * Math.pow(26, len - 1 - i);
    }
    return result;
  };

  _parse_sample_ex2 = (a) => {
    let x_s = 0;
    let y_s = 0;
    let x_e = 0;
    let y_e = 0;
    let ref = a["!ref"];
    let reg1 = /([a-zA-Z]+)([0-9]+):([a-zA-Z]+)([0-9]+)/gi;
    let res1 = reg1.exec(ref);
    x_s = this._column_2_number(res1[1]) - 1;
    y_s = Number(res1[2]) - 1;
    x_e = this._column_2_number(res1[3]);
    y_e = Number(res1[4]);

    x_e = x_e > 150 ? 150 : x_e;

    let result = new Array(y_e > 30 ? 30 : y_e);
    let array_value = new Array(y_e);
    for (let i = y_s; i < y_e; i++) {
      array_value[i] = [];
      if (i < 30) result[i] = [];
      for (let j = 0; j < x_e; j++) {
        array_value[i][j] = "";
        if (i < 30) result[i][j] = {};
      }
    }
    for (let k in a) {
      let reg = /([a-zA-Z]+)([0-9]+)/gi;
      let res = reg.exec(k);
      if (!res) continue;
      let x = this._column_2_number(res[1]) - 1;
      let y = Number(res[2]) - 1;
      let val = { value: a[k].v, type: a[k].t };
      if (y < 30) result[y][x] = val;
      array_value[y][x] = a[k].v;
      if (x === 3 && y === 39)
        if (y > this.options.limit)
          // b = 0;
          // console.log("x:"+x+",y"+y);

          break;
    }
    this.excel_data_array = array_value;
    return result;
  };

  excelGetSample = (sample, sheetName) => {
    let columns = [];
    this.setState({
      currentStep: 1,
      isLoading: false,
      status: "dataPreview",
      sheetName: sheetName,
      getSample: {
        items: sample,
        heads: columns,
      },
    });
  };

  _parse_columns = (items) => {
    let excel_title = this.excel_data_array[0];
    let result = [];
    if (!excel_title) return result;

    for (let k = 0; k < excel_title.length; k++) {
      excel_title[k] = excel_title[k].toString().trim();
    }

    let field_map = {};
    let i = 0;
    for (let k = 0; k < items.length; k++) {
      let label = items[k].label;
      if (items[k].widget.type === "address") {
        label = items[k].label + "(省/自治区/直辖市)";
      }

      if (
        BsyConfig().LimitFields.import.indexOf(items[k].widget.type) >
        -1 &&
        excel_title.indexOf(label) > -1
      ) {
        if (items[k].widget.type === "address") {
          let val = {
            rowspan: 1,
            colspan: 1,
            // col:k,
            text:
              items[k].label +
              React.language("widget.address.province.withMark"),
            match: {
              field: items[k].widget.widgetName,
              part: "province",
              text: items[k].label,
              type: items[k].widget.type,
            },
          };
          field_map[val["text"] + i.toString()] = val;
          i++;
          let val1 = {
            rowspan: 1,
            colspan: 1,
            // col:k+1,
            text: items[k].label + React.language("city.withMark"),
            match: {
              field: items[k].widget.widgetName,
              part: "city",
              text: items[k].label,
              type: items[k].widget.type,
            },
          };
          field_map[val1["text"] + i.toString()] = val1;
          i++;
          let val2 = {
            rowspan: 1,
            colspan: 1,
            // col:k+1,
            text:
              items[k].label +
              React.language("widget.address.district.withMark"),
            match: {
              field: items[k].widget.widgetName,
              part: "district",
              text: items[k].label,
              type: items[k].widget.type,
            },
          };
          field_map[val2["text"] + i.toString()] = val2;
          i++;
          if (items[k].widget.needDetail) {
            let val3 = {
              rowspan: 1,
              colspan: 1,
              // col:k+1,
              text:
                items[k].label +
                React.language("widget.address.detail.withMark"),
              match: {
                field: items[k].widget.widgetName,
                part: "detail",
                text: items[k].label,
                type: items[k].widget.type,
              },
            };
            field_map[val3["text"] + i.toString()] = val3;
            i++;
          }
        } else {
          let val = {
            rowspan: 1,
            colspan: 1,
            // col:k,
            text: items[k].label,
            match: {
              field: items[k].widget.widgetName,
              text: items[k].label,
              type: items[k].widget.type,
            },
          };
          field_map[val["text"] + i.toString()] = val;
          i++;
        }
      }
    }

    function getField(name, index) {
      let key = "";
      let val = {};
      let result = {};
      name = name.trim();
      BsyUtils.forEach(field_map, function (a1, b1) {
        if (!b1.hasOwnProperty("col")) {
          if (b1.text.trim() === name) {
            result = {
              key: a1,
              val: b1,
            };
            return !1;
          }
        }
      });

      return result;
    }

    BsyUtils.forEach(excel_title, function (a1, b1) {
      if (!b1) return;

      let ret = getField(b1, a1);
      if (ret.key) {
        field_map[ret.key].col = a1;
        ret.val.col = a1;
        result.push(ret.val);
      } else {
        let val = {
          rowspan: 1,
          colspan: 1,
          col: a1,
          text: b1,
        };
        result.push(val);
      }

      // if(!field_map[b1+a1])
      // {
      //     let val = {
      //         rowspan:1,
      //         colspan:1,
      //         col:a1,
      //         text:b1,
      //     };
      //     result.push(val);
      // }
      // else
      // {
      //     field_map[b1+a1].col = a1;
      //     result.push(field_map[b1+a1]);
      // }
    });
    return result;
  };
  _parse_sample1_ex = () => {
    let json = this.excel_data_array;
    let result = [];
    let n = json.length;
    for (let i = 1; i < n; i++) {
      let s = [];
      let row = json[i];
      let index = 0;
      BsyUtils.forEach(row, (k, v) => {
        s[index] = v;
        index++;
      });
      // for (let k in row) {
      //     s[index] = row[k];
      //     index++;
      // }
      if (i < 30) result.push(s);
    }
    return result;
  };

  excelMatchHead = () => {
    const { Sheets, sheetName, fields } = this.state;
    this.setState(
      {
        isLoading: true,
      },
      () => {
        let sample = this._parse_sample1_ex(Sheets[sheetName]);
        if (sample.length === 0) {
          // 工作簿为空
          tipAlert({
            type: "warning",
            msg: React.language("excel.export.tip24"),
          });
          this.setState({
            isLoading: false,
          });
          return;
        }
        if (!sample[0]) {
          // 表头为空,请调整后重新导入
          tipAlert({
            type: "warning",
            msg: React.language("excel.export.tip25"),
          });
          this.setState({
            isLoading: false,
          });
          return;
        }

        let columns = this._parse_columns(fields);

        this.setState({
          currentStep: 2,
          isLoading: false,
          status: "formSet",

          matchHead: {
            items: sample,
            heads: columns,
          },
        });
      }
    );
  };

  excel_2_js = (dateValue) => {
    let b = dateValue; //(dateValue - 25569) * 3600 * 24 * 1000;
    if (!BsyUtils.isNumber(b)) {
      return b;
    }
    return BsyUtils.date2Str(
      new Date(
        Math.round(
          (b - window.FX.Time.excelDayOffset) *
          window.FX.Time.millisecondsOfDay -
          window.FX.TimeZone.defaultOffset
        )
      ),
      "yyyy-MM-dd HH:mm:ss"
    );
  };

  makeData = () => {
    let address_map = {};
    let columnMatch = this.columnMatch;
    let col_map = [];
    for (let k = 0; k < columnMatch.length; k++) {
      if (columnMatch[k].match.type === "address") {
        if (!address_map[columnMatch[k].match.field]) {
          address_map[columnMatch[k].match.field] = [];
        }
        address_map[columnMatch[k].match.field][columnMatch[k].match.part] =
          columnMatch[k].col;
      }
      col_map[columnMatch[k].col] = columnMatch[k];
    }
    let items = this.excel_data_array;
    let result = [];
    for (let k = 1; k < items.length; k++) {
      let val = {};
      let is_empty = true;
      for (let k1 in col_map) {
        if (!col_map.hasOwnProperty(k1)) continue;

        let v = items[k][k1];
        if (!BsyUtils.isObjectEmpty(v)) {
          is_empty = false;
        }
        let widget = col_map[k1].match.field;
        let type = col_map[k1].match.type;

        switch (type) {
          case "address": {
            let v1 = {};
            if (address_map[widget]["province"])
              v1.province = items[k][address_map[widget]["province"]];
            if (address_map[widget]["city"])
              v1.city = items[k][address_map[widget]["city"]];
            if (address_map[widget]["district"])
              v1.district = items[k][address_map[widget]["district"]];
            if (address_map[widget]["detail"])
              v1.detail = items[k][address_map[widget]["detail"]];
            v = v1;
            break;
          }
          case "combocheck":
          case "checkboxgroup": {
            v = (v + "").split(",");
            break;
          }
          case "datetime": {
            // this.excel_2_js(v);
            if(BsyUtils.isExcelDateNumber(v)) {
              v = dayjsUtils.timeToLocal(BsyUtils.excelDate2Date(v)).date.getTime();
            } else {
              v = "";
            }
            break;
          }
          case "number": {
            const t = parseFloat(v);
            v = BsyUtils.isObjectEmpty(v) ? null : isNaN(t) ? null : t;
            break;
          }
          case "combo":
          case "radiogroup":
          case "sn":
          case "text": {
            v = v + "";
          }
          default:
        }

        // if (type == "combocheck" || type == "checkboxgroup")
        //   v = (v + "").split(",");
        // else if (type == "datetime") v = this.excel_2_js(v);
        // else if (type == "address") {
        //   let v1 = {};
        //   if (address_map[widget]["province"])
        //     v1.province = items[k][address_map[widget]["province"]];
        //   if (address_map[widget]["city"])
        //     v1.city = items[k][address_map[widget]["city"]];
        //   if (address_map[widget]["district"])
        //     v1.district = items[k][address_map[widget]["district"]];
        //   if (address_map[widget]["detail"])
        //     v1.detail = items[k][address_map[widget]["detail"]];
        //   v = v1;
        // }
        val[widget] = v;
      }
      if (!is_empty) {
        val.isNew = true;
        val.rowId = val.id = BsyUtils.Ids24();
        result.push(val);
      }
    }
    console.log(result);
    return result;
  };

  excelImport = () => {
    let that = this;
    this.setState(
      {
        isLoading: true,
      },
      () => {
        setTimeout(() => {
          let data = that.makeData();
          this.props.onRsyncData && this.props.onRsyncData(data);
          this.setState({
            isLoading: false,
            currentStep: 3,
            importData: data,
            status: "importData",
          });
        }, 100);
      }
    );
  };

  _check_limit = (excel_data, sheetName) => {
    let c = this,
      d = this.options;
    let data = excel_data[sheetName];
    let ref = data["!ref"];
    let reg1 = /([a-zA-Z]+)([0-9]+):([a-zA-Z]+)([0-9]+)/gi;
    let res1 = reg1.exec(ref);
    let y_e = Number(res1[4]);
    if (y_e > d.limit + 1) {
      tipAlert({
        type: "warning",
        msg: React.language("excel.export.tip12", { limit: d.limit }),
      });
      return false;
    }
    return true;
  };

  _s2ab = (s) => {
    //字符串转字符流
    let buf = new ArrayBuffer(s.length);
    let view = new Uint8Array(buf);
    for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };

  excelUpload = (e) => {
    let that = this;
    let files = e.target.files;

    if (files[0].size == 0) {
      tipAlert({
        msg: React.language("upload.maxLimitTip0"),
        type: "warning",
      });
      return;
    }

    let wb;
    let rABS = false;
    let f = files[0];
    let reader = new FileReader();
    reader.onload = function (e) {
      let data = e.target.result;
      wb = window.XLSX.read(data, { type: "binary" });

      let sheetName = wb.SheetNames[0];

      if (files && files.length > 0) {
        if (wb.Sheets[sheetName].hasOwnProperty("!merges")) {
          tipAlert({
            type: "warning",
            msg: React.language("excel.export.tip13"),
          });
        } else {
          if (!that._check_limit(wb.Sheets, sheetName)) {
            return;
          }
          const { ret, sample } = that.checkExcelData(wb.Sheets[sheetName]);
          if (!ret) {
            return;
          }
          that.setState(
            {
              currentStep: 1,
              status: "dataPreview",
              isLoading: false,
              Sheets: wb.Sheets,
              sheetName,
              fileinfo: { cacheKey: "", sheetList: wb.SheetNames },
            },
            () => {
              that.excelGetSample(sample, sheetName);
            }
          );
        }
      }
    };
    if (rABS) {
      reader.readAsArrayBuffer(f);
    } else {
      reader.readAsBinaryString(f);
    }
  };

  checkExcelData = (data) => {
    let sample = this._parse_sample_ex2(data);

    if (sample.length === 0) {
      // 工作簿为空
      tipAlert({
        type: "warning",
        msg: React.language("excel.export.tip24"),
      });
      return {
        sample: [],
        ret: false,
      };
    }
    if (!sample[0]) {
      // 表头为空,请调整后重新导入
      tipAlert({
        type: "warning",
        msg: React.language("excel.export.tip25"),
      });
      return {
        sample: [],
        ret: false,
      };
    }
    return {
      sample,
      ret: true,
    };
  };

  renderSelectExcel = () => {
    const { importCheckallowBlank, importCheckrepeat } = this.state;
    let fieldv = [];
    if (importCheckallowBlank) {
      fieldv.push(0);
    }
    if (importCheckrepeat) {
      fieldv.push(1);
    }
    return (
      <div
        className={"content " + this.state.status}
        key={"renderSelectExcel" + this.excelGridIndex}
      >
        <div className={"import-content "}>
          <ul className="bsy-import-tip">
            <span className="title">{React.language("Excel.title.tip")}</span>
            <li>
              <div className="tip"></div>
              <span>{React.language("Excel.title.tip2")}</span>
              <span className="x-c-key" onClick={this.downTemplte}>
                {React.language("Excel.title.tip3")}
              </span>
              <span>{React.language("import.excel.data")}</span>
            </li>
            <li>
              <div className="tip"></div>
              <span>{React.language("Excel.title.tip5", { limit: SUBFORM_MAX_LIMIT })}</span>
            </li>
            <li>
              <div className="tip"></div>
              <span>{React.language("Excel.title.tip6")}</span>
            </li>
          </ul>
        </div>

        <div className={"import-footer"}>
          <BsyIconBtn
            key={"btnselect" + this.excelGridIndex}
            text={React.language("select.file")}
            type={"blue"}
            file={true}
            accept={".xlsx,.xls"}
            onChange={(event) => {
              this.excelUpload(event);
            }}
            mode={window.mode}
          />
        </div>
      </div>
    );
  };

  renderDataPreview = () => {
    const { fileinfo, hasSubform, getSample, sheetName, Sheets } = this.state;
    let sheetItems = [];
    for (let i = 0; i < fileinfo.sheetList.length; i++) {
      sheetItems.push({
        value: fileinfo.sheetList[i],
        text: fileinfo.sheetList[i],
      });
    }
    return (
      <div
        className={"content " + this.state.status}
        key={"renderDataPreview" + this.excelGridIndex}
      >
        <div className={"import-content "}>
          <div className={"bsy-import-tool"}>
            <span className={"span-title"}>{React.language("excel")}</span>
            <BsySelect
              allowBlank={false}
              searchable={false}
              value={sheetName || fileinfo.sheetList[0]}
              width={160}
              items={sheetItems}
              onStopEdit={(val) => {
                this.lastSheetName = this.state.sheetName;
                this.setState(
                  {
                    isLoading: true,
                  },
                  () => {
                    const { ret, sample } = this.checkExcelData(Sheets[val]);
                    if (!ret) {
                      this.checkExcelData(Sheets[this.lastSheetName]); // 重置数据
                      this.setState({
                        isLoading: false,
                        sheetName: this.lastSheetName,
                      });
                      return;
                    }
                    this.excelGetSample(sample, val);
                  }
                );
              }}
            ></BsySelect>
          </div>
          <div className="bsy-import-excel">
            <BsyExcelGrid
              key={"BsyExcelGrid-" + this.excelGridIndex}
              hasSubform={hasSubform}
              items={getSample.items}
              heads={getSample.heads}
              formId={this.props.formId}
            ></BsyExcelGrid>
          </div>
        </div>
        <div className={"import-footer"}>
          <BsyIconBtn
            key={"btnnextStep" + this.excelGridIndex}
            text={React.language("nextStep")}
            type={"blue"}
            click={(event) => {
              this.excelMatchHead();
            }}
            mode={window.mode}
          />
          <BsyIconBtn
            key={"btnprevStep" + this.excelGridIndex}
            text={React.language("prevStep")}
            click={(event) => {
              this.setState({
                currentStep: 0,
                status: "selectExcel",
                fileinfo: {},
                sample: {},
              });
            }}
            mode={window.mode}
          />
        </div>
      </div>
    );
  };

  renderFormSet = () => {
    const {
      fileinfo,
      hasSubform,
      matchHead,
      sheetName,
      importCheckallowBlank,
      importCheckrepeat,
      importMode,
    } = this.state;
    let sheetItems = [];
    let that = this;
    for (let i = 0; i < fileinfo.sheetList.length; i++) {
      sheetItems.push({
        value: fileinfo.sheetList[i],
        text: fileinfo.sheetList[i],
      });
    }
    return (
      <div
        className={"content " + this.state.status}
        key={"renderFormSet" + this.excelGridIndex}
      >
        <div className={"import-content "}>
          <div className={"bsy-import-tool"}>
            <span className={"span-title"}>
              {React.language("excel.export.tip14")}
            </span>
            <BsyTextEditor
              enable={false}
              value={sheetName}
              width={160}
            ></BsyTextEditor>
          </div>
          <div className="bsy-import-excel">
            <BsyExcelGrid
              getContext={(context) => {
                this.excelGridContext = context;
              }}
              key={"BsyExcelGrid-" + this.excelGridIndex}
              hasSubform={hasSubform}
              items={matchHead.items}
              heads={matchHead.heads}
              showHead={true}
              headEnable={true}
              matchWidgets={
                importMode == 1 || importMode == 2
                  ? [{ value: "_id", text: "data_id" }, ...this.formItems]
                  : this.formItems
              }
              widgetsMap={
                importMode == 1 || importMode == 2
                  ? { _id: { type: "text" }, ...this.widgetsMap }
                  : this.widgetsMap
              }
              formId={this.props.formId}
              onAsyncSuccess={() => {
                that.columnMatch = [
                  ...this.excelGridContext.getColumnMatch(
                    importCheckallowBlank,
                    importCheckrepeat
                  ),
                ];
              }}
            ></BsyExcelGrid>
          </div>
        </div>
        <div className={"import-footer"}>
          <BsyIconBtn
            key={"btnnextStep" + this.excelGridIndex}
            text={React.language("nextStep")}
            type={"blue"}
            click={(event) => {
              this.excelCheckData();
            }}
            mode={window.mode}
          />
          <BsyIconBtn
            key={"btnprevStep" + this.excelGridIndex}
            text={React.language("prevStep")}
            click={(event) => {
              this.setState({
                currentStep: 1,
                status: "dataPreview",
              });
            }}
            mode={window.mode}
          />
        </div>
      </div>
    );
  };

  bsyimporttipbar = () => {
    const { errorData } = this;
    let m = "";

    if (errorData.errorInfoFileUrl) {
      m = React.language("import.failTip.second", {
        tip1:
          '<a href="' +
          (errorData.errorInfoFileUrl || "") +
          '" class="text-green download" target="_blank">' +
          React.language("import.failTip.second.tip1") +
          "</a>",
        tip2: React.language("import.failTip.second.tip2"),
      });
    }
    if (errorData.errorCount > 60) {
      return (
        <>
          <div className="bsy-import-tip-bar">
            <div>{React.language("excel.export.tip15")}</div>
            <div dangerouslySetInnerHTML={{ __html: m }}></div>
          </div>
          <div className="bsy-import-tip-bar-line"></div>
        </>
      );
    } else {
      return (
        <>
          <div className="bsy-import-tip-bar">
            <div>
              {React.language("import.fail.count", {
                count: errorData.errorCount,
              })}
            </div>
            <div dangerouslySetInnerHTML={{ __html: m }}></div>
          </div>
          <div className="bsy-import-tip-bar-line"></div>
        </>
      );
    }
  };

  renderImportData = () => {
    const { importData } = this.state;
    return (
      <div
        className={"content " + this.state.status}
        key={"renderImportData" + this.excelGridIndex}
      >
        <div className={"import-content "}>
          <div className="bsy-import-info">
            <div className="success">
              <i className="icon-right-circle"></i>
            </div>
            <div className="info">
              {React.language("import.data.tip", { len: importData.length })}
            </div>
          </div>
        </div>
        <div className={"import-footer"}>
          <BsyIconBtn
            key={"btnnextStep" + this.excelGridIndex}
            text={React.language("done")}
            type={"blue"}
            click={(event) => {
              let data = this.makeData();
              this.props.onFinish && this.props.onFinish(data);
              this.props.onClost && this.props.onClost();
            }}
            mode={window.mode}
          />
        </div>
      </div>
    );
  };

  _getErrorItems = (error, header) => {
    let that = this;
    var i = [];
    BsyUtils.forEach(error, (e, n) => {
      var a = {};
      BsyUtils.forEach(header, (e, t) => {
        var i = t.match && t.match.field;
        if (BsyUtils.isEmpty(n[i])) {
          a[t.col] = that.excel_data_array[n._id + 1][t.col];
        } else {
          if (t.subColumns && t.subColumns.length) {
            a[t.col] = [];
            var k = 0;
            //补齐列数据，后端返回的数据不完整
            BsyUtils.forEach(t.subColumns, function (key1, data) {
              if (k != 0) {
                a[t.col + k] = "";
              }
              k++;
            });
            BsyUtils.forEach(n[i], function (e, i) {
              var n = {};
              BsyUtils.forEach(t.subColumns, function (e, t) {
                if (t.match && t.match.field) {
                  var a = t.match.field;
                  if (i[a]) {
                    if (Array.isArray(i[a])) {
                      for (var j = 0; j < i[a].length; j++) {
                        i[a][j].col = t.col;
                        i[a][j].text = i[a][j].name;
                      }
                      n[t.col] = {
                        col: t.col,
                        value: i[a],
                      };
                    } else {
                      n[t.col] = i[a]; // i[a].name
                      a[t.col].col = t.col;
                      if (i[a].name) n[t.col].text = i[a].name;
                    }
                  } else {
                    n[t.col] = "";
                  }

                  // i[a] ? n[t.col] = i[a].name || i[a] : n[t.col] = ""
                } else n[t.col] = "";
              });
              a[t.col].push(n);
            });
          } else {
            if (n[i]) {
              if (Array.isArray(n[i])) {
                for (var j = 0; j < n[i].length; j++) {
                  n[i][j].col = t.col;
                  n[i][j].text = n[i][j].name;
                }
                a[t.col] = {
                  col: t.col,
                  value: n[i],
                };
              } else {
                a[t.col] = n[i]; // n[i].name || n[i]
                a[t.col].col = t.col;
                if (n[i].name) a[t.col].text = n[i].name;
              }
            } else {
              a[t.col] = "";
            }
            // n[i] ? a[t.col] = n[i].name || n[i] : a[t.col] = ""
          }
        }
      });
      i.push(a);
    });
    return i;
  };

  excelCheckData = () => {
    let that = this;

    var field = ["user", "dept", "usergroup", "deptgroup"];

    that.user_data = {};
    for (var k = 0; k < that.columnMatch.length; k++) {
      if (field.indexOf(that.columnMatch[k].match.type) > -1) {
        // col_map[columnMatch[k].col] = columnMatch[k];
        var b = that.columnMatch[k];
        that.user_data[b.match.field] = {
          col: b.col,
          type: b.match.type,
          data: [],
        };
      }
    }

    if (BsyUtils.isObjectEmpty(that.user_data)) {
      that.user_data = null;
      this.excelImport();
      return;
    }
    var items = that.excel_data_array;
    BsyUtils.forEach(that.user_data, function (a, b) {
      for (var k = 1; k < items.length; k++) {
        var v = items[k][b.col];
        b.data.push(v);
      }
    });

    this.setState({
      isLoading: true,
    });

    React.axios("/data/subformImportCheckUser", {
      items: that.user_data,
    })
      .then((res) => {
        if (res.data.errorCount == 0) {
          BsyUtils.forEach(res.data.items, function (a, b) {
            BsyUtils.forEach(b.data, function (a1, b1) {
              items[a1 + 1][b.col] = b1;
            });
          });
          that.excel_data_array = items;
          that.excelImport();
        } else {
          this.errorData = { ...res.data };
          this.setState({
            currentStep: 2,
            isLoading: false,
            hasError: that.errorData.errorCount > 0 ? true : false,
            status: "checkData",
          });
        }
      })
      .catch((res) => {
        console.error(res);
      });
  };

  renderCheckData = () => {
    const { hasSubform, matchHead, hasError } = this.state;
    const { errorData } = this;
    let that = this;
    var c1 = matchHead.heads;
    var d1 = this._getErrorItems(this.errorData.error_data, matchHead.heads);

    return (
      <>
        {this.bsyimporttipbar()}
        <div
          className={"content " + this.state.status}
          key={"renderImportData" + this.excelGridIndex}
          style={{
            height: "calc(100% - 95px)",
          }}
        >
          <div className={"import-content "}>
            {errorData.errorCount + errorData.checkErrorCount > 60 ? (
              <div
                className="bsy-import-error-info"
                style={{
                  height: 370,
                }}
              >
                <div className="info-title">
                  {React.language("fail.detail")}
                </div>
                {errorData.users.miss.length > 0 ? (
                  <>
                    <div className="info-label">
                      {React.language("import.contact.emptyUser")}
                    </div>
                    <div className="info-text">
                      {errorData.users.miss.join("、")}
                    </div>
                  </>
                ) : (
                  ""
                )}
                {errorData.users.repeat.length > 0 ? (
                  <>
                    <div className="info-label">
                      {React.language("excel.export.tip16")}
                    </div>
                    <div className="info-text">
                      {errorData.users.repeat.join("、")}
                    </div>
                  </>
                ) : (
                  ""
                )}
                {errorData.users.validity.length > 0 ? (
                  <>
                    <div className="info-label">
                      {React.language("excel.export.tip17")}
                    </div>
                    <div className="info-text">
                      {errorData.users.validity.join("、")}
                    </div>
                  </>
                ) : (
                  ""
                )}
                {errorData.depts.miss.length > 0 ? (
                  <>
                    <div className="info-label">
                      {React.language("import.contact.emptyDept")}
                    </div>
                    <div className="info-text">
                      {errorData.depts.miss.join("、")}
                    </div>
                  </>
                ) : (
                  ""
                )}
                {errorData.depts.repeat.length > 0 ? (
                  <>
                    <div className="info-label">
                      {React.language("excel.export.tip18")}
                    </div>
                    <div className="info-text">
                      {errorData.depts.repeat.join("、")}
                    </div>
                  </>
                ) : (
                  ""
                )}
                {errorData.widget.allowBlank.length > 0 ? (
                  <>
                    <div className="info-label">
                      {React.language("excel.export.tip20")}
                    </div>
                    <div className="info-text">
                      {errorData.widget.allowBlank.join("、")}
                    </div>
                  </>
                ) : (
                  ""
                )}
                {errorData.widget.repeat.length > 0 ? (
                  <>
                    <div className="info-label">
                      {React.language("excel.export.tip19")}
                    </div>
                    <div className="info-text">
                      {errorData.widget.repeat.join("、")}
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            ) : (
              <div
                className="bsy-import-excel"
                style={{
                  height: 370,
                }}
              >
                <BsyExcelGrid
                  getContext={(context) => {
                    this.checkDataExcelGridContext = context;
                  }}
                  key={"BsyExcelGrid-" + this.excelGridIndex}
                  hasSubform={hasSubform}
                  items={d1}
                  heads={c1}
                  showHead={true}
                  matchWidgets={this.formItems}
                  widgetsMap={this.widgetsMap}
                  formId={this.props.formId}
                  errorData={this.errorData.error_data}
                  onCheckData={(val, cb) => {
                    // this.checkDataRepeat(val, cb)
                  }}
                  onUpdateError={() => {
                    let dd = this.checkDataExcelGridContext.getFixedDataList();
                    // this.setState({
                    //     hasError: dd[0] ? true : false,
                    // })
                    this.nextImport.current.setVisible(
                      dd[2] === 0 ? true : false
                    );
                  }}
                  onAsyncSuccess={() => {
                    // that.columnMatch = [...this.excelGridContext.getColumnMatch(importCheckallowBlank, importCheckrepeat)]
                  }}
                ></BsyExcelGrid>
              </div>
            )}
          </div>
          <div className={"import-footer"}>
            <BsyIconBtn
              key={"btnnextStep" + this.excelGridIndex}
              ref={this.nextImport}
              text={React.language("nextStep")}
              type={"blue "}
              click={(event) => {
                let dd = this.checkDataExcelGridContext.getFixedDataList();
                let fixedDataList = dd[1];

                var fields = {};
                BsyUtils.forEach(that.errorData.items, function (a, b) {
                  fields[a] = b;
                  BsyUtils.forEach(b.data, function (a1, b1) {
                    that.excel_data_array[a1 + 1][b.col] = b1;
                  });
                });
                BsyUtils.forEach(fixedDataList, function (a, b) {
                  BsyUtils.forEach(b, function (a1, b1) {
                    var xls_data =
                      that.excel_data_array[parseInt(a) + 1][fields[a1].col];
                    if (BsyUtils.isArray(xls_data)) {
                      if (!b1) {
                        b1 = [];
                      }
                      BsyUtils.forEach(xls_data, function (a2, b2) {
                        b1.push(b2._id);
                      });
                    }
                    that.excel_data_array[parseInt(a) + 1][fields[a1].col] = b1;
                  });
                });

                this.excelImport();
              }}
              mode={window.mode}
            />

            <BsyIconBtn
              key={"btnprevStep" + this.excelGridIndex}
              text={React.language("prevStep")}
              click={(event) => {
                // this.excelMatchHead();
                this.setState({
                  currentStep: 2,
                  status: "formSet",
                });
              }}
              mode={window.mode}
            />
          </div>
        </div>
      </>
    );
  };

  renderContent = () => {
    const { status } = this.state;
    switch (status) {
      case "dataPreview":
        return this.renderDataPreview();
      case "formSet":
        return this.renderFormSet();
      case "checkData":
        return this.renderCheckData();
      case "importData":
        return this.renderImportData();
      case "selectExcel":
      default: {
        return this.renderSelectExcel();
      }
    }
  };

  render() {
    const { steps, currentStep, isLoading } = this.state;
    const { cssName } = this.options;
    this.excelGridIndex++;
    return (
      <div
        className={cssName + (isLoading ? " loading " : "")}
        ref={this.element}
      >
        {
          <BsyStepPane
            key={"step-" + new Date().getTime()}
            steps={steps}
            currentStep={currentStep}
          ></BsyStepPane>
        }
        {this.renderContent()}
        {isLoading && <BsySLoading />}
      </div>
    );
  }
}
